export default function () {
  return 1;
}